"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![CompletedIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgaGVpZ2h0PSIzMCIgd2lkdGg9IjMwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+Q29tcGxldGVkPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTgsMTZhOCw4LDAsMSwxLDgtOEE4LDgsMCwwLDEsOCwxNlpNOCwxYTcsNywwLDEsMCw3LDdBNyw3LDAsMCwwLDgsMVoiLz4KICAgICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNS45LDExLjY4YS40Ny40NywwLDAsMS0uMzUtLjE1TDMuNCw5LjM4YS41LjUsMCwwLDEsMC0uNzEuNS41LDAsMCwxLC43LDBsMS44LDEuOCw2LTZhLjUuNSwwLDAsMSwuNywwLC41LjUsMCwwLDEsMCwuNzFMNi4yNSwxMS41M0EuNDcuNDcsMCwwLDEsNS45LDExLjY4WiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.CompletedIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16 16", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M8 16a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7z" }),
        React.createElement("path", { d: "M5.9 11.68a.47.47 0 0 1-.35-.15L3.4 9.38a.5.5 0 0 1 0-.71.5.5 0 0 1 .7 0l1.8 1.8 6-6a.5.5 0 0 1 .7 0 .5.5 0 0 1 0 .71l-6.35 6.35a.47.47 0 0 1-.35.15z" })));
};
//# sourceMappingURL=Icon.Completed.js.map